import { render, staticRenderFns } from "./NotificationHolder.vue?vue&type=template&id=988c575c&scoped=true&"
import script from "./NotificationHolder.vue?vue&type=script&lang=ts&"
export * from "./NotificationHolder.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationHolder.vue?vue&type=style&index=0&id=988c575c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988c575c",
  null
  
)

export default component.exports